import * as Yup from "yup";
import { Formik } from "formik";
import { QrReader } from "react-qr-reader";
import { useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  Label,
  LoadingButton,
  OuterBox,
  SubheaderSection,
  TextField,
} from "../../components";
import {
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Typography,
} from "@mui/material";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { Switch, FormControlLabel } from "@mui/material"; // add import
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";

import UserDetails from "./UserDetails";
import { useAxios } from "../../hooks";
import { setDisplayName } from "../../redux/slices/memberSlice";

const ManualEntry = () => {
  const axios = useAxios({
    baseURL: "mox_api_2",
  });

  const dispatch = useDispatch();

  const { authToken, displayName, eventID } = useSelector(
    (state) => state.memberDetails
  );

  const [guardDetails, setGuardDetails] = useState({
    name: displayName || "",
    gateNo: 0,
    QRCode: "",
    phoneNumber: "", // ✅ added phone field
    ImgData: "",
    reason: "",
    userDetails: undefined,
    isAllowed: true,
    usePhone: false,
  });

  const [loading, setLoading] = useState(false);
  const [userStep, setUserStep] = useState("");
  const [gates, setGates] = useState([]);
  const [agentName, setAgentName] = useState(displayName || "");
  const [selectedGate, setSelectedGate] = useState(
    Number(sessionStorage.getItem("gateMate")) || 0
  );

  const [entryStatus, setEntryStatus] = useState(undefined);
  const [faceVerificationStatus, setFaceVerificationStatus] =
    useState(undefined);
  const [appointmentStatus, setAppointmentStatus] = useState(undefined);
  const [mainEntryStatus, setMainEntryStatus] = useState(undefined);
  const [bookingExistStatus, setBookingExistStatus] = useState(undefined);

  const [entityType, setEntityType] = useState([]);
  const [userLocation, setUserLocation] = useState({
    gate_type: "tablet",
    lat: "",
    lng: "",
  });
  const [eventList, setEventList] = useState([]);

  useEffect(() => {
    axios({
      url: "entry/entry/entity-type",
      disableRedirect: true,
      disableError: true,
    }).then((response) => {
      setEntityType(response.data);
    });
  }, []);

  useEffect(() => {
    if (Boolean(displayName)) {
      setUserStep("QRcode");
    }

    // axios({
    //   url: "/visitor/dome-list",
    //   disableRedirect: true,
    //   disableError: true,
    // }).then((response) => {
    //   if (response.status) {
    //     setGates(response.data);
    //   }
    // });
  }, []);

  function fetchUserDetails(formikProps, bookingId, eventID) {
    setLoading(true);

    const payload = {
      machine_id: formikProps.values.gateNo,
      booking_id: bookingId,
      user_type_id: 4,
      phone_number: formikProps.values.phoneNumber || undefined, // ✅ support phone lookup
    };

    axios({
      url: "entry/entry/manual-verification",
      method: "POST",
      customAuthToken: authToken,
      data: payload,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setUserStep("userDetails");
        formikProps.setValues((prevValues) => ({
          ...prevValues,
          userDetails: response?.data,
        }));
      } else {
        setAppointmentStatus(response?.data?.appointment_status);
        setFaceVerificationStatus(response?.data?.face_verification);
        setMainEntryStatus(response?.data?.main_entry);
        setBookingExistStatus(response?.data?.booking_exist);
      }
      setLoading(false);
    });
  }

  function handleGetLocation(position) {
    setUserLocation({
      gate_type: "tablet",
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    });
  }
  function handleError() {}
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(handleGetLocation, handleError);
  });

  return (
    <OuterBox>
      {!entryStatus &&
        entryStatus === undefined &&
        faceVerificationStatus === undefined &&
        appointmentStatus === undefined && (
          <Formik
            initialValues={guardDetails}
            validationSchema={validationSchema}
            onSubmit={(formData, { setSubmitting }) => {
              setSubmitting(true);

              axios({
                url: "/entry/entry",
                method: "POST",
                data: {
                  machine_id: formData?.gateNo,
                  visitor_id: formData?.userDetails?.visitor_id,
                  gate_type: "tablet",
                  ...userLocation,
                },
                customAuthToken: "9beaa95b-c59f-4ec9-bb60-5f4ee1986311",
                disableRedirect: true,
              }).then((response) => {
                if (response.status) {
                  setEntryStatus(response.status);
                } else {
                  setEntryStatus(response.status);
                  setAppointmentStatus(response.data?.appointment_status);
                  setFaceVerificationStatus(response.data?.face_verification);
                }
                setSubmitting(false);
              });
            }}
          >
            {(formikProps) => {
              function handleEventId(e) {
                axios({
                  url: `entry/entry/machine-list?entity_id=${e.target.value}`,
                  disableRedirect: true,
                  disableError: true,
                  customAuthToken: "9beaa95b-c59f-4ec9-bb60-5f4ee1986311",
                }).then((response) => {
                  if (response.status) {
                    setGates(response.data);
                  }
                  formikProps.setFieldValue("eventID", e.target.value);
                });
              }

              function handleEntityType(e) {
                axios({
                  url: "/entry/entry/entity-list?entity_type=" + e.target.value,
                  disableRedirect: true,
                  disableError: true,
                }).then((response) => {
                  if (response.status) {
                    setEventList(response.data);
                  } else {
                    setEventList([]);
                  }
                  formikProps.setFieldValue("entityType", e.target.value);
                });
              }
              return (
                <Fragment>
                  {userStep === "" && (
                    <Grid container>
                      <Grid item xs={12}>
                        <TextField
                          select
                          name="entityType"
                          placeholder="Select Entity Type"
                          formikProps={formikProps}
                          onChange={handleEntityType}
                        >
                          {entityType.map((item, index) => {
                            return (
                              <MenuItem key={index} value={item.entity_id}>
                                {item.name?.toUpperCase()}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </Grid>

                      <Grid item xs={12} marginTop={"10px"}>
                        <TextField
                          select
                          name="eventID"
                          placeholder="Select Event Name"
                          formikProps={formikProps}
                          onChange={handleEventId}
                          disabled={!formikProps.values.entityType}
                        >
                          {eventList?.map((item, index) => {
                            return (
                              <MenuItem key={index} value={item?.entity_id}>
                                {item?.name?.toUpperCase()}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </Grid>

                      <Grid item xs={12} marginTop={"10px"}>
                        <LoadingButton
                          variant="contained"
                          sx={{ height: "100%" }}
                          disabled={!formikProps.dirty || !eventList.length}
                          onClick={() => {
                            dispatch(setDisplayName(formikProps.values.name));
                            setUserStep("QRcode");
                          }}
                        >
                          Submit
                        </LoadingButton>
                      </Grid>
                    </Grid>
                  )}

                  {userStep === "QRcode" && (
                    <Grid container>
                      {!Boolean(formikProps.values.userDetails) && (
                        <Fragment>
                          <Grid item xs={12}>
                            <Typography variant="h5" textAlign={"center"}>
                              First Select Gate No
                            </Typography>
                          </Grid>

                          <Grid item container m={3} justifyContent={"center"}>
                            <Grid item xs={4}>
                              <TextField
                                select
                                name="gateNo"
                                formikProps={formikProps}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  setSelectedGate(value);
                                  sessionStorage.setItem("gateMate", value);
                                  formikProps.setValues((prev) => ({
                                    ...prev,
                                    gateNo: value,
                                  }));
                                }}
                                value={selectedGate}
                              >
                                <MenuItem value={0}>
                                  Select Your Current Gate
                                </MenuItem>
                                {gates.map((item) => (
                                  <MenuItem
                                    key={item.machine_id}
                                    value={item.machine_id}
                                  >
                                    {item.zone_name}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>
                          </Grid>
                        </Fragment>
                      )}

                      {/* ✅ Switch between QR / Phone */}
                      {!formikProps.values.userDetails &&
                        !appointmentStatus &&
                        !loading && (
                          <Fragment>
                            <Grid item xs={12} textAlign="center" mt={3}>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={formikProps.values.usePhone}
                                    onChange={(e) =>
                                      formikProps.setFieldValue(
                                        "usePhone",
                                        e.target.checked
                                      )
                                    }
                                  />
                                }
                                label={
                                  formikProps.values.usePhone
                                    ? "Phone Number Entry"
                                    : "QR Code Scan"
                                }
                              />
                            </Grid>

                            {/* Show QR Scanner if switch OFF */}
                            {!formikProps.values.usePhone && (
                              <Grid
                                item
                                container
                                justifyContent="center"
                                mt={2}
                              >
                                <Grid item sx={{ width: "50vh" }}>
                                  <QrReader
                                    style={{ width: "100%" }}
                                    onResult={(result, error) => {
                                      if (!!result) {
                                        let [eventID, bookingID] =
                                          result?.text.split("_");
                                        fetchUserDetails(
                                          formikProps,
                                          result?.text,
                                          eventID
                                        );
                                      }
                                      if (!!error) console.info(error);
                                    }}
                                    constraints={{ facingMode: "environment" }}
                                    scanDelay={250}
                                  />
                                </Grid>
                              </Grid>
                            )}

                            {/* Show Phone input if switch ON */}
                            {formikProps.values.usePhone && (
                              <Grid
                                item
                                container
                                justifyContent="center"
                                alignItems="center"
                                mt={2}
                                spacing={2}
                              >
                                <Grid item xs={6}>
                                  <TextField
                                    name="phoneNumber"
                                    label="Phone Number"
                                    formikProps={formikProps}
                                    fullWidth
                                  />
                                </Grid>
                                <Grid item>
                                  <LoadingButton
                                    variant="contained"
                                    disabled={!formikProps.values.phoneNumber}
                                    onClick={() => {
                                      fetchUserDetails(
                                        formikProps,
                                        null,
                                        eventID
                                      );
                                    }}
                                  >
                                    Fetch Details
                                  </LoadingButton>
                                </Grid>
                              </Grid>
                            )}
                          </Fragment>
                        )}

                      {loading && (
                        <Grid
                          container
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          m={15}
                        >
                          <CircularProgress sx={{ color: "green" }} />
                          <Typography
                            variant="h6"
                            sx={{ mt: "30px" }}
                            fontWeight="600"
                          >
                            Wait Getting User Details
                          </Typography>
                        </Grid>
                      )}
                    </Grid>
                  )}

                  {Boolean(formikProps.values.userDetails) &&
                    userStep === "userDetails" && (
                      <UserDetails formikProps={formikProps} />
                    )}
                </Fragment>
              );
            }}
          </Formik>
        )}

      {/* ✅ Keep rest of your success/failure blocks as they were */}
      {entryStatus && (
        <Grid
          container
          display={"flex"}
          sx={{ flexDirection: "column" }}
          alignItems="center"
          justifyContent={"center"}
        >
          <CheckCircleOutlineRoundedIcon
            sx={{
              fontSize: "80px",
              color: "rgb(41 128 31)",
              marginBottom: "30px",
            }}
          />
          <Typography
            variant="h1"
            component="h2"
            sx={{
              fontWeight: 700,
              fontSize: "18px",
              textAlign: "center",
              textTransform: "uppercase",
              color: "rgb(41 128 31)",
            }}
          >
            User Access Granted
          </Typography>
          <Button
            variant="outlined"
            sx={{ marginTop: "30px" }}
            onClick={() => {
              setUserStep("QRcode");
              setEntryStatus(undefined);
              setAppointmentStatus(undefined);
              setFaceVerificationStatus(undefined);
              setMainEntryStatus(undefined);
              setBookingExistStatus(undefined);
            }}
          >
            Take Next Entry
          </Button>
        </Grid>
      )}
    </OuterBox>
  );
};

// ✅ Validation Schema updated with phone number
const validationSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .matches(/^[0-9]{10}$/, "Enter a valid 10-digit phone number")
    .nullable(),
  reason: Yup.string().when("isAllowed", {
    is: (val) => val === false,
    then: Yup.string().required("Reason is required"),
    otherwise: Yup.string(),
  }),
});

export default ManualEntry;
